<template>
    <div class="vip-purchase-container">
      <h1 class="title">升级到 VIP</h1>
      <p class="subtitle">选择最适合您的 VIP 套餐，享受更多高级功能</p>
  
      <el-row :gutter="20" class="vip-plans">
        <el-col :span="8" v-for="plan in vipPlans" :key="plan.id">
          <el-card :class="['vip-plan', { 'popular': plan.popular }]">
            <template #header>
              <div class="plan-header">
                <h2>{{ plan.name }}</h2>
                <span v-if="plan.popular" class="popular-tag">最受欢迎</span>
              </div>
            </template>
            <div class="plan-price">
              <span class="currency">￥</span>
              <span class="amount">{{ plan.price }}</span>
              <span class="period">/月</span>
            </div>
            <ul class="plan-features">
              <li v-for="feature in plan.features" :key="feature">
                <el-icon><Check /></el-icon>
                {{ feature }}
              </li>
            </ul>
            <el-button type="primary" @click="selectPlan(plan)" :class="{ 'is-popular': plan.popular }">
              选择此套餐
            </el-button>
          </el-card>
        </el-col>
      </el-row>
  
      <el-dialog v-model="dialogVisible" title="确认购买" width="30%">
        <p>您已选择 {{ selectedPlan.name }} 套餐</p>
        <p>价格：￥{{ selectedPlan.price }}/月</p>
        <template #footer>
          <span class="dialog-footer">
            <el-button @click="dialogVisible = false">取消</el-button>
            <el-button type="primary" @click="confirmPurchase">
              确认支付
            </el-button>
          </span>
        </template>
      </el-dialog>
    </div>
  </template>
  
  <script setup>
  import { ref } from 'vue'
  import { Check } from '@element-plus/icons-vue'
  import { ElMessage } from 'element-plus'
  
  const vipPlans = ref([
    {
      id: 1,
      name: '基础版',
      price: 29,
      features: ['每日100次请求', '标准模型访问', '基础客户支持'],
      popular: false
    },
    {
      id: 2,
      name: '高级版',
      price: 99,
      features: ['每日500次请求', '高级模型访问', '优先客户支持', '自定义模型训练'],
      popular: true
    },
    {
      id: 3,
      name: '企业版',
      price: 299,
      features: ['无限请求', '所有模型访问', '24/7专属支持', '自定义模型训练', 'API集成'],
      popular: false
    }
  ])
  
  const dialogVisible = ref(false)
  const selectedPlan = ref({})
  
  const selectPlan = (plan) => {
    selectedPlan.value = plan
    dialogVisible.value = true
  }
  
  const confirmPurchase = () => {
    // 这里应该实现实际的支付逻辑
    ElMessage({
      message: `感谢您购买 ${selectedPlan.value.name} 套餐！`,
      type: 'success'
    })
    dialogVisible.value = false
  }
  </script>
  
  <style scoped>
  .vip-purchase-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 40px 20px;
  }
  
  .title {
    font-size: 2.5rem;
    text-align: center;
    margin-bottom: 10px;
    color: #ffd700;
  }
  
  .subtitle {
    font-size: 1.2rem;
    text-align: center;
    margin-bottom: 40px;
    color: #999;
  }
  
  .vip-plans {
    margin-top: 40px;
  }
  
  .vip-plan {
    height: 100%;
    display: flex;
    flex-direction: column;
    transition: transform 0.3s ease;
  }
  
  .vip-plan:hover {
    transform: translateY(-10px);
  }
  
  .vip-plan.popular {
    border: 2px solid #ffd700;
  }
  
  .plan-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .popular-tag {
    background-color: #ffd700;
    color: #1a1a1a;
    padding: 2px 8px;
    border-radius: 12px;
    font-size: 0.8rem;
    font-weight: bold;
  }
  
  .plan-price {
    font-size: 2rem;
    text-align: center;
    margin: 20px 0;
  }
  
  .currency, .period {
    font-size: 1rem;
    vertical-align: super;
  }
  
  .plan-features {
    list-style-type: none;
    padding: 0;
    margin-bottom: 20px;
  }
  
  .plan-features li {
    margin-bottom: 10px;
    display: flex;
    align-items: center;
  }
  
  .plan-features .el-icon {
    margin-right: 10px;
    color: #67c23a;
  }
  
  .el-button {
    margin-top: auto;
  }
  
  .el-button.is-popular {
    background-color: #ffd700;
    border-color: #ffd700;
    color: #1a1a1a;
  }
  
  .el-button.is-popular:hover {
    background-color: #f0c800;
    border-color: #f0c800;
  }
  </style>